import MailchimpSubscribe from 'react-mailchimp-subscribe';
import { Newsletter } from './Newsletter';

export const MailchimpForm = () => {
  const baseUrl = import.meta.env.VITE_MAILCHIMP_URL;
  const userId = import.meta.env.VITE_MAILCHIMP_U;
  const audienceId = import.meta.env.VITE_MAILCHIMP_ID;

  if (!baseUrl || !userId || !audienceId) return null;

  const postUrl = `${baseUrl}?u=${userId}&id=${audienceId}`;
  return (
    <MailchimpSubscribe
      url={postUrl}
      render={({ subscribe, status, message }) => (
        <Newsletter status={status} message={message} onValidated={(formData) => subscribe(formData)} />
      )}
    />
  );
};
